import { ENVIRONMENT } from '@app/environment';
import { DOCUMENTS } from '@introspection/documents';
import { introspectionQueryResultData } from '@introspection/fragmentTypes';
import { Module } from '@rxdi/core';
import { convertToPossibleTypes, GraphqlModule, GraphQLRequest, InMemoryCache } from '@rxdi/graphql-client';
import * as firebase from 'firebase/app';

import { AiService, CategoryService as OldCategoryService } from './services';
import { BlogService } from './services/blog/blog.service';
import { CategoryService, PageService, ProductService } from './services/steelfab';

@Module({
  imports: [
    GraphqlModule.forRoot(
      {
        async onRequest(this: GraphQLRequest) {
          const headers = new Headers();
          const user = firebase.auth().currentUser;

          if (user) {
            headers.append('authorization', await user.getIdToken());
          }
          return headers;
        },
        cache: new InMemoryCache({
          possibleTypes: convertToPossibleTypes(introspectionQueryResultData),
          typePolicies: {
            Query: {
              fields: {
                listSteelFabProducts: {
                  merge: (existing, incoming) => incoming,
                },
                listSteelFabCategories: {
                  merge: (existing, incoming) => incoming,
                },
              },
            },
          },
        }),
        uri: ENVIRONMENT.GRAPH_URL,
        pubsub: ENVIRONMENT.GRAPH_WS_URL,
        httpOptions: {
          useGETForQueries: true,
        },
      },
      DOCUMENTS
    ),
  ],
  providers: [BlogService, OldCategoryService, AiService, CategoryService, ProductService, PageService],
})
export class CoreModule {}
